import smartSnippet from "../../services/smartSnippet";

const smartSnippetPlugin = function (editor) {
  editor.ui.registry.addMenuButton("smartsnippets", {
    text: "Smart Snippets",
    fetch(callback) {
      const articleId = editor.getParam("article_id");
      const inherits = editor.getParam("inherits");
      let language = editor.getParam("language_code");

      if (!language || language === "") {
        language = editor.id;
      }

      smartSnippet.getSmartSnippets(language, articleId, inherits).then(function (resp) {
        const items = resp.map((item) => ({
          type: "menuitem",
          text: item.displayName,
          onAction() {
            editor.insertContent(item.value);
          }
        }));
        callback(items);
      });
    }
  });
};

export { smartSnippetPlugin };
